import React from 'react';

const Priority = ({ rowData }) => {
    return (
        <span>
            {
                rowData.priority === "l" ?
                    "کم" :
                rowData.priority === "h" &&
                    "زیاد"
            }
        </span>
    );
}

export default Priority;
